import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  showImportSubnav: boolean = false;
  showOrderImportSubnav: boolean = false;
  showReportSubnav: boolean = false;
  currentUrl: string;
  public Role: string;

  constructor(private router: Router) {
    router.events.subscribe((_: NavigationEnd) => this.currentUrl = _.url);
  }

  ngOnInit() {
    this.Role = localStorage.getItem('role');
  }

  showImportSubMenu() {
    this.showImportSubnav = !this.showImportSubnav;
  }
  showOrderImportSubMenu() {
    this.showOrderImportSubnav = !this.showOrderImportSubnav;
  }
  showReportSubMenu() {
    this.showReportSubnav = !this.showReportSubnav;
  }

}
